import { createVNode as n, mergeProps as s } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/QuestionTwoTone.js";
import m from "../components/PfIcon.js";
const o = (e, t) => {
  const r = {
    ...e,
    ...t.attrs
  };
  return n(m, s(r, {
    icon: i
  }), null);
};
o.displayName = "QuestionTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
